import React from 'react';
import './HeaderMain.scss';

const HeaderMain = (props) => {
    const { moveToPackage, moveToProduct, moveToContact } = props;

    return (
        <div className="header fixed">
            <div className="header-container">
                <a className="header-logo" href="/">
                    <img alt=''/>
                </a>
                <ul className="header-nav pc">
                    <li>
                        <button onClick={moveToPackage}>
                            <span>PACKAGE</span>
                        </button>
                    </li>
                    <li>
                        <button onClick={moveToProduct}>
                            <span>PRODUCT</span>
                        </button>
                    </li>
                    <li>
                        <button onClick={moveToContact}>
                            <span>CONTACT</span>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default HeaderMain;
